module.exports = __webpack_public_path__ + "img/202504_05.fd27a1b8.jpg";